const safeArray = (v) => (Array.isArray(v) ? v : [])

export const norm = (v) =>
  String(v || '')
    .trim()
    .toLowerCase()

export const parseDate = (value) => {
  if (!value) return null
  if (value instanceof Date) return value
  if (typeof value === 'string') return new Date(value)
  if (value.$date) return new Date(value.$date)
  return null
}

export const isNoExpiry = (item) => item?.noExpiry === true

export const getId = (value) => {
  if (!value) return ''
  if (typeof value === 'string') return value
  if (value.$oid) return value.$oid
  return String(value)
}

export default function getSectionStatusSummary(
  section,
  inventoryItems = [],
  missingList = [],
) {
  const now = new Date()
  const soon = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000)

  const norm = (v) =>
    String(v || '')
      .trim()
      .toLowerCase()

  const parseDate = (value) => {
    if (!value) return null
    if (value instanceof Date) return value
    if (typeof value === 'string') return new Date(value)
    if (value.$date) return new Date(value.$date)
    return null
  }

  const isNoExpiry = (item) => item?.noExpiry === true

  const requiredConsumables = Array.isArray(section?.requiredConsumables)
    ? section.requiredConsumables
    : []

  const expiredItems = []
  const expiringSoonItems = []
  const inDateItems = []
  const obsoleteItems = []

  let missing = 0

  const isRequiredItem = (item) =>
    requiredConsumables.some(
      (requiredItem) =>
        norm(requiredItem.name) === norm(item.name) &&
        norm(requiredItem.size) === norm(item.size),
    )

  for (const requiredItem of requiredConsumables) {
    const matches = inventoryItems.filter(
      (item) =>
        norm(item.name) === norm(requiredItem.name) &&
        norm(item.size) === norm(requiredItem.size),
    )

    const validItems = matches.filter((item) => {
      if (isNoExpiry(item)) return true

      const expiry = parseDate(item.expiryDate)
      return expiry && expiry > now
    })

    const requiredQty = Number(requiredItem.quantity || 0)
    const missingCount = requiredQty - validItems.length

    if (missingCount > 0) missing += missingCount

    for (const item of matches) {
      if (isNoExpiry(item)) {
        inDateItems.push(item)
        continue
      }

      const expiry = parseDate(item.expiryDate)
      if (!expiry) continue

      if (expiry < now) expiredItems.push(item)
      else if (expiry <= soon) expiringSoonItems.push(item)
      else inDateItems.push(item)
    }
  }

  for (const item of inventoryItems) {
    if (!isRequiredItem(item)) obsoleteItems.push(item)
  }

  const missingItems = missingList.filter(
    (i) => norm(i.section) === norm(section.sectionName),
  )

  return {
    missing,
    expired: expiredItems.length,
    almostExpired: expiringSoonItems.length,
    expiredItems,
    expiringSoonItems,
    inDateItems,
    obsoleteItems,
    missingItems,
  }
}
